/* WRAPJKT: progressively enhance the existing home; links and posters work without JS. */
(() => {
  'use strict';
  if (window.wjHomePerformance) return;
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 768px)');
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const listen = (node, type, handler, cleanup) => {
    node.addEventListener(type, handler);
    cleanup.push(() => node.removeEventListener(type, handler));
  };
  function mount(root) {
    if (instances.has(root)) return;
    const cleanup = [], videos = [...root.querySelectorAll('video[data-wj-home-video]')];
    const inlineToggles=new Map();
    const hero = root.querySelector('[data-wj-home-hero]');
    const toggle = hero && hero.querySelector('[data-wj-video-toggle]');
    const states = new Map(videos.map(video => [video, {visible: !window.IntersectionObserver, userPaused: false, manual: false}]));
    const active = video => !video.dataset.device || (desktop.matches ? video.dataset.device === 'desktop' : video.dataset.device === 'mobile');
    function load(video) {
      if (video.getAttribute('src')) return;
      if (video.dataset.src) { video.src = video.dataset.src; video.load(); }
    }
    function label() {
      inlineToggles.forEach((button,video)=>{button.textContent=video.error?'Reintentar vídeo':video.paused?'Ver vídeo':'Pausar vídeo';button.setAttribute('aria-label',button.textContent+': '+(video.getAttribute('aria-label')||'WRAPJKT'));});
      if (!toggle) return;
      const video = videos.find(v => active(v) && v.closest('[data-wj-home-hero]'));
      const paused = !video || video.paused;
      toggle.textContent = paused ? 'Reproducir vídeo' : 'Pausar vídeo';
      toggle.setAttribute('aria-label', paused ? 'Reproducir vídeo de portada' : 'Pausar vídeo de portada');
      toggle.hidden = false;
    }
    function sync(video) {
      if(document.querySelector('dialog[open]')){video.pause();label();return;}
      const state = states.get(video);
      if(state&&!video.closest('[data-wj-home-hero]')&&!state.manual){video.pause();label();return;}
      if (!state) return;
      if (document.hidden || !active(video) || !state.visible || state.userPaused || ((reduced.matches || saveData) && !state.manual)) {
        if (active(video) && state.visible && !video.closest('[data-wj-home-hero]') && (reduced.matches || saveData)) { video.controls = true; load(video); }
        video.pause(); label(); return;
      }
      load(video); video.muted = true;
      const play = video.play();
      if (play && play.catch) play.catch(() => { if (!video.closest('[data-wj-home-hero]')) video.controls = true; label(); });
    }
    function syncAll() { videos.forEach(sync); label(); }
    videos.forEach(video => {
      if(!video.closest('[data-wj-home-hero]')&&!video.closest('a')){const button=document.createElement('button');button.type='button';button.className='wj-home-inline-toggle';button.textContent='Ver vídeo';video.parentElement.append(button);inlineToggles.set(video,button);listen(button,'click',()=>{const state=states.get(video);state.userPaused=!video.paused;state.manual=true;state.visible=true;video.controls=true;if(video.error){video.removeAttribute('src');video.load();state.userPaused=false;}sync(video);label();},cleanup);cleanup.push(()=>button.remove());}
      listen(video, 'play', () => { document.querySelectorAll('video').forEach(other => {if(other!==video)other.pause();}); label(); }, cleanup);
      listen(video, 'pause', label, cleanup);
      listen(video, 'error', label, cleanup);
    });
    if (window.IntersectionObserver && videos.length) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          states.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio > 0;
          sync(entry.target);
        });
      }, {threshold: [0, 0.1]});
      videos.forEach(video => observer.observe(video));
      cleanup.push(() => observer.disconnect());
    }
    if (toggle) listen(toggle, 'click', () => {
      const video = videos.find(v => active(v) && v.closest('[data-wj-home-hero]'));
      if (!video) return;
      const state = states.get(video);
      state.userPaused = !video.paused; state.manual = true; state.visible = true;
      sync(video); label();
    }, cleanup);
    listen(document, 'visibilitychange', syncAll, cleanup);
    listen(window, 'pagehide', () => videos.forEach(video => video.pause()), cleanup);
    [desktop, reduced].forEach(media => {
      if (media.addEventListener) listen(media, 'change', syncAll, cleanup);
      else { media.addListener(syncAll); cleanup.push(() => media.removeListener(syncAll)); }
    });
    const counters = [...root.querySelectorAll('[data-wj-deadline]')];
    let timer;
    function tick() {
      clearTimeout(timer);
      if (document.hidden || !root.isConnected) return;
      let future = false;
      counters.forEach(node => {
        const delta = Date.parse(node.dataset.wjDeadline) - Date.now();
        if (!Number.isFinite(delta)) return;
        let value = 'EDICIÓN CERRADA';
        if (delta > 0) {
          future = true;
          const d = Math.floor(delta / 86400000), h = Math.floor(delta / 3600000) % 24;
          const m = Math.floor(delta / 60000) % 60, s = Math.floor(delta / 1000) % 60;
          value = `${d}D : ${String(h).padStart(2,'0')}H : ${String(m).padStart(2,'0')}M : ${String(s).padStart(2,'0')}S`;
        }
        if (node.textContent !== value) node.textContent = value;
      });
      if (future) timer = setTimeout(tick, 1000);
    }
    if (counters.length) { tick(); listen(document, 'visibilitychange', tick, cleanup); }
    syncAll();
    instances.set(root, () => { clearTimeout(timer); cleanup.forEach(fn => fn()); videos.forEach(video => video.pause()); });
  }
  function start(scope = document) {
    if (scope.matches && scope.matches('[data-wj-home-scope]')) mount(scope);
    scope.querySelectorAll('[data-wj-home-scope]').forEach(mount);
  }
  window.wjHomePerformance = {start};
  start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, root) => {
      if (root === event.target || event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
})();
